import { Container } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { AfterPageProps, wrapLayout } from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import ContactHqInfo from './components/ContactHqInfo';
import ContactInfoSection from './components/ContactInfoSection';
import { contactInfoSections, hqInfo } from './ContactsPage.constants';

export type ContactsPageProps = AfterPageProps;
export type ContactsPageClassNameKey =
  | 'root'
  | 'personFrame'
  | 'firstSection'
  | 'firstSectionRow'
  | 'firstSectionInfoBox'
  | 'secondSection'
  | 'secondSectionRow'
  | 'subtitle'
  | 'sectionThree'
  | 'personsFrameWrapper'
  | 'sectionFour'
  | 'mapNumber'
  | 'map'
  | 'departmentManager'
  | 'lastChildCenter';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingTop: '150px',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '5rem',
    },
  }),
);

const ContactsPage: React.FC<ContactsPageProps> = () => {
  const classes = useStyles();

  return (
    <Container>
      <div className={classes.root}>
        {contactInfoSections.map((section, index) => (
          <ContactInfoSection data={section} key={index} />
        ))}
        <ContactHqInfo data={hqInfo} />
      </div>
    </Container>
  );
};

ContactsPage.displayName = 'ContactsPage';

export default wrapLayout(ContactsPage, InfoLayout);
